import styled from "styled-components";

export const StatusMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > p {
    font-size: 30px;
    color: black;
    text-align: center;
  }
  @media (max-width: 600px) {
    & > p {
      font-size: 20px;
    }
  }
`;

export const StyledIcondiv = styled.div`
  // width: 32px;
  // height: 32px;
  // background: red;
  border-radius: 100%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    font-size: 108px;
  }
`;
